import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface CancelInvoiceRequest {
  cancelReason: string;
}

export interface CreateCreditNoteRequest {
  reasonCode?: string;
  notes?: string;
}

export interface CreateCreditNoteResponse {
  creditNoteId: string;
  creditNoteTotal: number;
  cashMovementId: string;
  openingId: string;
  amountSigned: number;
  links: {
    invoiceId: string;
    creditNoteId: string;
  };
}

export interface ApiResponse<T> {
  success: boolean;
  code: string;
  reason: string;
  requestResult: T;
  body: T;
}

@Injectable({
  providedIn: 'root'
})
export class InvoicesService {
  private apiUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) { }

  cancelInvoice(invoiceId: string, request: CancelInvoiceRequest): Observable<ApiResponse<boolean>> {
    return this.http.post<ApiResponse<boolean>>(
      `${this.apiUrl}/api/v1/Invoices/${invoiceId}/cancel`,
      request
    );
  }

  getInvoiceById(invoiceId: string): Observable<ApiResponse<any>> {
    return this.http.get<ApiResponse<any>>(
      `${this.apiUrl}/api/v1/Invoices/${invoiceId}`
    );
  }

  createCreditNoteForCashInvoice(invoiceId: string, request: CreateCreditNoteRequest): Observable<ApiResponse<CreateCreditNoteResponse>> {
    return this.http.post<ApiResponse<CreateCreditNoteResponse>>(
      `${this.apiUrl}/api/v1/Invoices/${invoiceId}/credit-note`,
      request
    );
  }
}
